<template>
  <div class="button-div">
    <div class="div-chexbox-button">
      <ListMenuWithCheckbox
        v-if="showZoneMenu || showZoneMenuHover"
        :title="title"
        :categories="categories"
        @onChecklistToggle="updateFilteredLayersPlanview"
        @onHoverListMenu="$emit('onHoverListMenu')"
        @closeHoverListMenu="$emit('closeHoverListMenu')"
      />
      <ButtonSquareHoverChecklist
        :title="$t('general__data__area-zones')"
        :imgSource="require('@/assets/icons-general/icon-layers.svg')"
        size="large"
        style="padding-top: 24px"
        :activeState="activeState"
        @clicked="toggleVisible"
        @hovered="emitHover"
        @mouseleave="$emit('mouseleave')"
      />
    </div>
  </div>
</template>

<script>
import ButtonSquareHoverChecklist from '@/components/general/buttons/ButtonSquareHoverChecklist.vue'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import { PLANVIEW_PREFIX } from '@/store/module-prefixes'
import { SET_SHOW_ZONE_MENU } from '@/store/mutation-types'
import { GET_INDOOR_ZONE_DATA_FOR_LEVEL } from '@/store/action-types'
import ListMenuWithCheckbox from '@/components/general/lists/ListMenuWithCheckbox/ListMenuWithCheckbox.vue'

export default {
  name: 'PlanViewFilterButton',
  components: {
    ButtonSquareHoverChecklist,
    ListMenuWithCheckbox
  },
  props: {
    categories: {
      type: Array,
      required: true
    },
    showZoneMenuHover: {
      type: Boolean
    },
    title: {
      type: String,
      required: true
    }
  },

  emits: [
    'mouseleave',
    'PlanViewFilterButtonHovered',
    'onChecklistToggle',
    'onHoverListMenu',
    'closeHoverListMenu'
  ],
  data() {
    return {
      active: false
    }
  },
  computed: {
    ...mapState({
      showZoneMenu: (state) => state.showZoneMenu
    }),
    ...mapGetters({
      selectedLevelId: 'selectedLevelId'
    }),
    activeState() {
      if (!this.categories.length) {
        return 'deactivated'
      }
      if (this.showZoneMenu) {
        return 'active'
      } else {
        return 'inactive'
      }
    }
  },
  methods: {
    toggleVisible() {
      if (this.activeState === 'deactivated') return
      this.active = !this.showZoneMenu
      this.setShowZoneMenu(this.active)
    },
    updateFilteredLayersPlanview(typeId, categoryId, checked) {
      this.$emit('onChecklistToggle', typeId, categoryId, checked)
    },
    emitHover() {
      this.$emit('PlanViewFilterButtonHovered')
    },
    hideHoverButtons() {
      this.active = false
      this.setShowZoneMenu(this.active)
    },
    ...mapActions(PLANVIEW_PREFIX, {
      getIndoorZoneDataForLevel: GET_INDOOR_ZONE_DATA_FOR_LEVEL
    }),
    ...mapMutations({
      setShowZoneMenu: SET_SHOW_ZONE_MENU
    })
  }
}
</script>

<style lang="scss" scoped>
.button-div {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.div-chexbox-button {
  display: flex;
  justify-content: center;
}
</style>
